import './Footer.css';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <span>© {new Date().getFullYear()} Thomas Amand</span>
      </div>
    </footer>
  );
}

export default Footer;
